export const MAX_FILE_SIZE = 10000000;
export const VALID_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx'];
export const VALID_FILE_TYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'image/jpeg',
    'image/png',
    'video/mp4',
    'video/avi',
    'video/x-matroska',
];
export const MAX_FILE_SIZES: Record<string, number> = {
    'application/msword': 50 * 1024 * 1024,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 50 * 1024 * 1024,
    'application/vnd.ms-powerpoint': 50 * 1024 * 1024,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 50 * 1024 * 1024,
    'application/pdf': 50 * 1024 * 1024,
    'image/jpeg': 50 * 1024 * 1024,
    'image/png': 50 * 1024 * 1024,
    'video/mp4': 1 * 1024 * 1024 * 1024,
    'video/avi': 1 * 1024 * 1024 * 1024,
    'video/x-matroska': 1 * 1024 * 1024 * 1024,
};
export const getMaxFileSize = (fileType: string) => {
    return MAX_FILE_SIZES[fileType] ?? null;
};
export const FILE_EXISTS_ERROR = 'File already exists.';
export const KNOWLEDGEBAE_CONTENT_PATH = '/knowledge-base/content';
export const KB_QNA = {
    import: 'import',
    export: 'export',
    delete: 'trash',
};

export const formFieldArray = [
    {
        name: 'ContentSourceName',
        displayName: 'Content Source Name',
        value: '',
        type: 'string',
        placeholder: 'Type unique content source name here...',
    },
    {
        name: 'Domain',
        displayName: 'Domain',
        value: '',
        type: 'string',
        placeholder: 'Type domain here...',
    },
    {
        name: 'TENANTID',
        displayName: 'TENANT ID',
        value: '',
        type: 'string',
        placeholder: 'Type tenant id here...',
    },
    {
        name: 'ClientId',
        displayName: 'Client Id',
        value: '',
        type: 'string',
        placeholder: 'Type client id here...',
    },
    {
        name: 'ClientSecret',
        displayName: 'Client Secret',
        value: '',
        type: 'string',
        placeholder: 'Type client secret here...',
    },
];

export const sourceType = {
    document: 'Ginger Document Hub',
    sharePoint: 'SharePoint',
};
export const ALL_FILES = 'All files';
export const LibraryViewType = {
    AllFiles: 'AllFiles',
    LibraryDetail: 'LibraryDetail',
};
